import { Modal } from "react-bootstrap";
import CloseBtn from "./ReuseableCompos/CloseBtn";

type Props = {
  onCloseBtnClick?: () => void;
  children?: React.ReactNode;
  anotherBtn?: React.ReactNode;
  noBorder?: boolean;
};

const CustomModalHeader = ({
  onCloseBtnClick,
  children,
  anotherBtn,
  noBorder,
}: Props) => {
  const borderNone = { border: "none" };
  return (
    <Modal.Header style={noBorder && borderNone}>
      {anotherBtn}
      <Modal.Title>{children}</Modal.Title>
      <CloseBtn closeModal={onCloseBtnClick} />
    </Modal.Header>
  );
};

export default CustomModalHeader;
